import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

const FAILSAFE_MS = 3000;

// An installed binary built before the plugin was added still runs the current bundle under live
// reload, so the call can reject; a splash that fails to hide is not worth an error.
const ignore = () => {};

export function hideSplashScreen(): void {
	if (Capacitor.isNativePlatform()) SplashScreen.hide().catch(ignore);
}

/** The root route's error element renders instead of RootLayout, which would otherwise never hide the splash. */
export function installSplashScreenFailsafe(): void {
	if (Capacitor.isNativePlatform()) setTimeout(hideSplashScreen, FAILSAFE_MS);
}
